/**
 * IMPORTS
 */
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { removerCaracteresInvisiveisEPadronizarEspacos } from "@pages/client/details-model/view-model/helpers/remover-caracteres-invisiveis-e-padronizar-espacos";

/**
 * Normaliza o valor de uma célula importada (Excel/planilha).
 *
 * Regras:
 * - Datas (Date) → formatadas para dd/MM/yyyy
 * - Strings de data (dd/MM/yyyy) → normalizadas
 * - Strings comuns → removerCaracteresInvisiveisEPadronizarEspacos
 * - Outros tipos → mantidos
 */
function handleNormalizeImportedCellValue(value: unknown) {
  if (value === null || value === undefined) return value;

  //  data real (Excel parseado)
  if (value instanceof Date) {
    return format(value, "dd/MM/yyyy", { locale: ptBR });
  }

  // String
  if (typeof value === "string") {
    const valorSanitizado = removerCaracteresInvisiveisEPadronizarEspacos(value);

    // detecta formato dd/MM/yyyy
    const brDateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = valorSanitizado.match(brDateRegex);

    if (match) {
      const [, day, month, year] = match;

      const date = new Date(Number(year), Number(month) - 1, Number(day));

      return format(date, "dd/MM/yyyy", { locale: ptBR });
    }

    return valorSanitizado;
  }

  return value;
}

/**
 * EXPORTS
 */
export { handleNormalizeImportedCellValue };
